"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTranscriptProperty = exports.transcriptPropertyDefinition = void 0;
exports.transcriptPropertyDefinition = {
    view: { label: 'Transcript' },
    constraints: [
        {
            name: 'stencils',
            argument: ['event-details'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'transcript',
};
const isTranscriptProperty = (prop) => {
    return prop.name === exports.transcriptPropertyDefinition.name;
};
exports.isTranscriptProperty = isTranscriptProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNjcmlwdC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RyYW5zY3JpcHQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFO0lBQzdCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsZUFBZSxDQUFDO1NBQzVCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBSTFCLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxJQUFrQixFQUE4QixFQUFFO0lBQ3JGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvQ0FBNEIsQ0FBQyxJQUFJLENBQUE7QUFDeEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQkFBb0Isd0JBRWhDIn0=